var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 294 293",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{clip-path:url(#clippath);}.cls-2{fill:none;}.cls-2,.cls-3{stroke-width:0px;}.cls-3{fill:#ffc400;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 10.18,
    y: 9,
    width: 277,
    height: 277
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_15"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1",
    className: "cls-3",
    d: "M205.23,284.48h-112.69c-44.62-.05-80.78-36.21-80.84-80.84v-112.69c.05-44.62,36.21-80.78,80.84-80.84h112.71c44.62.05,80.78,36.21,80.84,80.84v112.71c-.05,44.62-36.21,80.78-80.84,80.84M92.54,33.86c-31.48.12-56.97,25.61-57.09,57.09v112.71c.12,31.48,25.61,56.97,57.09,57.09h112.71c31.48-.12,56.97-25.61,57.09-57.09v-112.71c-.12-31.48-25.61-56.97-57.09-57.09h-112.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2",
    className: "cls-3",
    d: "M148.88,218.53c-39.34,0-71.23-31.89-71.23-71.23s31.89-71.23,71.23-71.23,71.23,31.89,71.23,71.23c-.05,39.32-31.91,71.18-71.23,71.23M148.88,99.81c-26.22,0-47.48,21.26-47.48,47.48,0,26.22,21.26,47.48,47.48,47.48s47.48-21.26,47.48-47.48h0c-.03-26.21-21.27-47.45-47.48-47.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3",
    className: "cls-3",
    d: "M237,75.01c0,9.03-7.32,16.35-16.35,16.35-9.03,0-16.35-7.32-16.35-16.35s7.32-16.35,16.34-16.35c9.03,0,16.35,7.32,16.35,16.35h0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaIcon);
export default __webpack_public_path__ + "static/media/insta_icon.6d02e9578709a289a19f8dfc8f42192c.svg";
export { ForwardRef as ReactComponent };